/* !
 * jQuery product_blank v1.0.0
 * Copyright 2025, Connecty Inc.
 */
(function ($, THERMOS) {

	// jnl-506ds
	if (THERMOS.va.pathname === '/product/series/jnl-506ds.html') {
		$('#jnl-506ds_sliderB-slide').slick({
			slidesToShow: 5.4,
			infinite: true,
			dots: true,
			prevArrow: '<button type="button" class="slick-prev"></button>',
			nextArrow: '<button type="button" class="slick-next"></button>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						centerMode: true
					}
				}
			]
		});
		$('#jnl-506ds_sliderW-slide').slick({
			slidesToShow: 5,
			infinite: true,
			dots: true,
			prevArrow: '<button type="button" class="slick-prev"></button>',
			nextArrow: '<button type="button" class="slick-next"></button>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
	}


})(window.jQuery, window.THERMOS);